import {
  DepositIcon,
  TradeIcon,
  TransferData,
  WithdrawIcon,
} from "assets/Icon";
import { Grid, IconButton, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import NumberFormats from "components/NumberFormats";
import Price from "./components/Price";
import SrcCoin from "./components/SrcCoin";
import Table from "components/Table";
import WalletActions from "components/WalletActions";
import useIsMobileView from "hooks/useIsMobileView";

const headers = [
  {
    key: "srcCoin",
    align: "left",
    name: "Src / Dst",
    sortable: true,
    sortKey: "coinSourceName",
  },
  {
    key: "buy",
    align: "left",
    name: "Buy / Sell",
    sortable: true,
    sortKey: "priceBuy",
  },
  {
    key: "broker",
    align: "left",
    name: "Broker",
    sortable: true,
    sortKey: "brokerName",
  },
  {
    key: "high24HourBuy",
    align: "left",
    name: "High(24h)",
    sortable: true,
    sortKey: "high24Hour",
  },
  {
    key: "low24HourBuy",
    align: "left",
    name: "Low(24h)",
    sortable: true,
    sortKey: "low24Hour",
  },
  {
    key: "actions",
    align: "center",
    name: "Actions",
  },
];

const headersMobile = [
  {
    key: "srcCoin",
    align: "left",
    sortable: true,
    name: "Coin",
    sortKey: "coinSourceName",
  },
  {
    key: "buy",
    align: "left",
    sortable: true,
    name: "Price",
    sortKey: "priceBuy",
  },
  {
    key: "broker",
    align: "left",
    sortable: true,
    name: "Broker",
    sortKey: "brokerName",
  },
];

export function TableMarket({ marketList }) {
  const theme = useTheme();
  const isMobileView = useIsMobileView();
  const navigate = useNavigate();

  // eslint-disable-next-line no-unused-vars
  const [_, setSearchParams] = useSearchParams();

  const [showWalletAction, setShowWalletAction] = useState(false);
  const [selectedCoin, setSelectedCoin] = useState(null);

  const formattedDataList = marketList?.map((data, index) => {
    return {
      data: data,
      srcCoin: <SrcCoin data={data} />,
      buy: <Price data={data} />,
      broker: data?.brokerName,
      high24HourBuy: (
        <Typography variant="h6" fontWeight="400" color="text.main">
          <NumberFormats
            displayType={"text"}
            value={parseFloat(data.high24Hour)}
          />
        </Typography>
      ),
      low24HourBuy: (
        <Typography variant="h6" fontWeight="400" color="text.main">
          <NumberFormats
            displayType={"text"}
            value={parseFloat(data.low24Hour)}
          />
        </Typography>
      ),
      actions: (
        <IconButton color="text" onClick={() => navigate("/trade/1/3")}>
          <Typography>Trade</Typography>
        </IconButton>
      ),
    };
  });

  const handleClickRow = (e) => {
    if (isMobileView) {
      const rowData = e?.data;

      navigate(`/trade/${rowData.coinSourceId}/${rowData.coinDestinationId}`);
    }
  };

  const walletActionItems = [
    {
      icon: (
        <WithdrawIcon
          color={theme.palette.secondary.main}
          width={"24px"}
          height={"24px"}
        />
      ),
      text: "Withdraw",
      onClick: (data) => navigate(`/withdraw/${data.coinSourceId}`),
    },
    {
      icon: (
        <DepositIcon
          color={theme.palette.secondary.main}
          width={"24px"}
          height={"24px"}
        />
      ),
      text: "Deposit",
      onClick: (data) => navigate(`/deposit/${data.coinSourceId}`),
    },
    {
      icon: (
        <TradeIcon
          color={theme.palette.secondary.main}
          width={"24px"}
          height={"24px"}
        />
      ),
      text: "Trade",
      onClick: (data) =>
        navigate(`/trade/${data.coinSourceId}/${data.coinDestinationId}`),
    },
    {
      icon: <TransferData color={theme.palette.secondary.main} />,
      text: "Transfer",
      onClick: (data) => {
        setSearchParams({
          transfer: data?.coinSourceId,
          transferSideId: 2,
        });
      },
    },
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <Table
          onRowClick={handleClickRow}
          headers={isMobileView ? headersMobile : headers}
          items={formattedDataList}
        />

        <WalletActions
          items={walletActionItems}
          open={showWalletAction}
          coin={selectedCoin}
          setCoin={setSelectedCoin}
          onClose={() => {
            setShowWalletAction(false);
          }}
        />
      </Grid>
    </Grid>
  );
}

export default TableMarket;
